import { LitElement, html, TemplateResult } from 'lit';
import { property } from 'lit/decorators.js';
import { styles } from '../view/styles';
import type { TableHeader, TableItem } from '../types';

export class GzTableWebComponent extends LitElement {
  @property({ type: Array, attribute: true, reflect: true })
  data: Array<TableItem> = [];

  @property({ type: Object, attribute: true, reflect: true })
  head: TableHeader = {};

  @property({ type: Boolean, attribute: true, reflect: true })
  classicTableStyle = false;

  static get styles() {
    return styles;
  }

  render() {
    return html`
      <table class="table" part="table">
        ${this.renderTableHeader(this.head)}
        <tbody>
          ${this.data.map(data => this.renderTableRow(data))}
        </tbody>
      </table>
    `;
  }

  private renderTableHeader(head: TableHeader): TemplateResult | undefined {
    const { header, color, hideTextLabel } = head;

    return html`
      <thead>
        ${header &&
        header.map((dataHeader, index) => {
          const colorIndex = color ? color[index] : null;
          return GzTableWebComponent.renderTableHeaderRow(dataHeader, index, colorIndex, hideTextLabel);
        })}
      </thead>
    `;
  }

  private renderTableRow(data: TableItem): TemplateResult | undefined {
    const { label, value } = data;

    if (label) {
      return html`
        <tr part="table-row">
          <td part="cell-label" class="label">${label}</td>
          ${value && (value as (string | number)[]).map(dataValue => GzTableWebComponent.renderTableCell(dataValue))}
        </tr>
      `;
    }

    return html`
      <tr>
        ${value && (value as (string | number)[]).map(dataValue => GzTableWebComponent.renderTableCell(dataValue))}
      </tr>
    `;
  }

  private static renderTableCell(value: string | number) {
    return html` <td part="cell-value" class="value">${value}</td> `;
  }

  private static renderTableHeaderRow(
    header: string,
    index: number,
    color?: string | null,
    hideTextLabel: boolean | undefined = false
  ): TemplateResult {
    return html`
      <th>
        <div class="label-container">
          ${color ? GzTableWebComponent.renderTableHeaderColor(color, index) : null}
          <span class="${hideTextLabel ? 'header-text-hidden' : 'header-text-visible'}"> ${header} </span>
        </div>
      </th>
    `;
  }

  private static renderTableHeaderColor(color: string, index: number): TemplateResult {
    return html` <span style="background-color: var(${color});" data-index="${index}"></span> `;
  }
}
